import { FaCheckSquare, FaRegCheckSquare } from "react-icons/fa";

const Checkbox = ({
	checked,
	onChange,
}: {
	checked: boolean;
	onChange: (checked: boolean) => void;
}) => {
	const CheckedIcon = FaCheckSquare as React.ElementType;
	const UncheckedIcon = FaRegCheckSquare as React.ElementType;

	return (
		<button onClick={() => onChange(!checked)} className="text-blue-600">
			{checked ? <CheckedIcon size={24} /> : <UncheckedIcon size={24} />}
		</button>
	);
};

export default Checkbox;
